import {Validators} from "@angular/forms";
import {WebsiteLinkFormField} from "../types/mb-website-links-modal.types";

export const websiteLinkFormFields: Array<WebsiteLinkFormField> = [
  {
    fieldName: 'link',
    label: 'Ссылка',
    validators: [ Validators.required ]
  }
]
